import * as React from 'react';
import { Typography, Menu } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { NavLink } from 'react-router-dom';

export function MenuPopupState({
  label,
  idxItem,
  IconComponent,
  items,
  onClick,
}) {
  const handleClick = (item, onClose) => {
    onClick(idxItem, item);
    onClose();
  };

  return (
    <PopupState className="popup" variant="popover">
      {(popupState) => (
        <React.Fragment>
          <Typography className="popup__label" {...bindTrigger(popupState)}>
            <span>{label}</span> <IconComponent />
          </Typography>

          <Menu
            className="popup__menu"
            {...bindMenu(popupState)}
            elevation={0}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            disableScrollLock={true}
          >
            {items.map((item, index) => (
              <NavLink key={index} to={item.to}>
                <MenuItem
                  className="popup__item"
                  onClick={() => handleClick(item, popupState.close)}
                >
                  {item.label}
                </MenuItem>
              </NavLink>
            ))}
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
